export default {
  container: {
    padding: ['40px 20px 0 20px', '26px 30px 0 30px', '62px 0 0 0'],
    margin: '0 auto',
    maxWidth: ['100%', '910px'],
  },
  eventGuideWrapper: {
    fontFamily: 'heading',
    color: '#333D47',
    title: {
      fontSize: ['24px', '40px', '60px'],
      fontFamily: 'spoqaBold',
      marginBottom: ['20px', '', '68px'],
      color: '#28313A',
      textTransform: 'uppercase',
    },
    eventsWrapper: {
      width: '100%',
      flexDirection: 'row',
      flexWrap: 'wrap',
    },
    event: {
      fontFamily: 'heading',
      width: ['100%', '100%', '50%'],
      marginBottom: ['37px', '37px', '37px'],

      '&:last-child': {
        marginBottom: '0px',
      },

      strong: {
        fontWeight: 'bold',
      },
      'h1, h2, h3, h4, h5, h6': {
        margin: '0px',
        fontSize: ['16px', '16px', '25px'],
        fontFamily: 'bold',
      },
      p: {
        fontSize: ['14px', '16px', '24px'],
        margin: '0px',
      },
    },
  },
}
